export const DEFAULT_LANGUAGE = 'zh'
export const FALLBACK_LANGUAGE = 'zh'
export const SUPPORTED_LANGUAGES = ['en', 'zh']
export const LANGUAGES_CODES = [
    { 'name': 'en', 'label': 'Eng', 'fb': 'en_GB' },
    { 'name': 'zh', 'label': '中', 'fb': 'zh_CN' },
]